import InputLayout from "./InputLayout";
import { getImageURL } from "../../utils/imageUrl";
import { Image } from "primereact/image";
import dummy from "../../assets/images/placeholder-img.png";

export const NewCustomViewImage = ({
    image,
    col,
    label,
    ...props
}) => {
    return (
        <div>
            <InputLayout col={col}>
                <div className="flex flex-column w-full">
                    {label && <label className="mb-2 w-8rem">{label}</label>}
                    <Image
                        src={image ? getImageURL(image) : dummy}
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = dummy;
                        }}
                        alt={image}
                        width="90"
                        height="90"
                        preview
                    />
                </div>
            </InputLayout>
        </div>
    );
};